import { render } from "./Staffs.vue?vue&type=template&id=17924189"
const script = {}

import "./Staffs.vue?vue&type=style&index=0&id=17924189&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__